import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDmswtVqcsbMShX5hrT_cKwISvEGZshw8Q",
  authDomain: "yudl-21359.firebaseapp.com",
  projectId: "yudl-21359",
  storageBucket: "yudl-21359.appspot.com",
  messagingSenderId: "651484514636",
  appId: "1:651484514636:web:8930b2a91b19bf6e5927e9",
  measurementId: "G-0NCHTPGD6P",
};

const app = initializeApp(firebaseConfig) 

export const auth = getAuth(app);
export const db = getFirestore(app);